module.exports = __webpack_public_path__ + "public/img/agile_3.88a117c1.png";